import { z } from 'zod';

export type UpdatePlayersOfTeamPayload = z.infer<typeof updatePlayersOfTeamPayloadSchema>;

export const updatePlayersOfTeamPayloadSchema = z.object({
  add: z.array(z.uuid()).optional(),
  remove: z.array(z.uuid()).optional(),
});
